/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { fg } from '@atlassian/jira-feature-gating';

import type { IssueAppEntryPointEntrypointProps } from './IssueAppEntryPoint.entrypoint.types.tsx';

const EMPTY_OBJECT = {} as const;
type IssueAppEntryPointComponent = EntryPointComponent<
	{},
	{},
	IssueAppEntryPointEntrypointProps,
	{}
>;

export const issueAppEntryPoint: EntryPoint<IssueAppEntryPointComponent, {}> = createEntryPoint({
	root: JSResourceForUserVisible<IssueAppEntryPointComponent>(
		/* webpackChunkName: "async-issue-app-entrypoint" */ './IssueAppEntrypoint.tsx',
		{ entryFsSsrLiftImportToModule: true },
	),
	getPreloadProps: () => (fg('nike-react-compiler-nin-transition-fixes') ? EMPTY_OBJECT : {}),
});
